import UnitActions from './actions'

const initialState = {
  isFetching: false,
  isError: false,
  messageError: null,
  items: [],
  currentItem: {
    item: null,
    isFetching: false,
    isError: false,
    messageError: null
  },
  unit: {
    item: null,
    isFetching: false,
    isError: false,
    messageError: null
  },
  school: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null,
    paginate: {
      page: 1,
      pageCount: 1,
      perPage: 10,
      total: 0
    }
  }
}

function UnitReducer (state = initialState, action) {
  switch (action.type) {
    case UnitActions.SCHOOL_FETCH_REQUEST:
      return {
        ...state,
        school: {
          ...state.school,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case UnitActions.SCHOOL_FETCH_SUCCESS:
      return {
        ...state,
        school: {
          ...state.school,
          items: action.payload.data,
          isFetching: false,
          isError: false,
          messageError: null,
          paginate: {
            ...state.school.paginate,
            total: action.payload.totalCount,
            pageCount: Math.ceil(action.payload.totalCount / state.school.paginate.perPage)
          }
        }
      }
    case UnitActions.SCHOOL_FETCH_ERROR:
      return {
        ...state,
        school: {
          ...state.school,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case UnitActions.SCHOOL_CHANGE_ACTIVE_PAGE:
      return {
        ...state,
        school: {
          ...state.school,
          paginate: {
            ...state.school.paginate,
            page: action.payload
          }
        }
      }
    case UnitActions.UNIT_CHANGE_REQUEST:
      return {
        ...state,
        currentItem: {
          ...state.currentItem.item,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case UnitActions.UNIT_CHANGE_SUCCESS:
      return {
        ...state,
        currentItem: {
          ...state.currentItem.item,
          item: action.payload,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case UnitActions.UNIT_CHANGE_ERROR:
      return {
        ...state,
        currentItem: {
          ...state.currentItem.item,
          item: null,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case UnitActions.GET_UNIT_REQUEST:
      return {
        ...state,
        unit: {
          ...state.unit.item,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case UnitActions.GET_UNIT_SUCCESS:
      return {
        ...state,
        unit: {
          ...state.unit.item,
          item: action.payload,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case UnitActions.GET_UNIT_ERROR:
      return {
        ...state,
        unit: {
          ...state.unit.item,
          item: null,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    default:
      return state
  }
}

export default UnitReducer



// WEBPACK FOOTER //
// ./src/modules/unit/reducers.js